import {
  ChevronRight,
  ChevronDown,
  FolderGit2,
  Settings2,
  PlayCircle,
  Plus,
  Play,
  RotateCcw,
  ChartColumn,
} from "lucide-react";
import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { apiFetch, apiFetch_ } from "../apiFetch";
import UploadProgress from "./ProgressSocketComponent";
import { useEffect } from "react";

export default function ProgramExplorer({ programs }) {
  const navigate = useNavigate();

  const [expandedPrograms, setExpandedPrograms] = useState([]);
  const [expandedConfigs, setExpandedConfigs] = useState([]);
  const [reRunId, setReRunId] = useState(null);
  const [fileProcessingStatus,setFileProcessingStatus] = useState()

  const toggleProgram = (id) => {
    setExpandedPrograms((prev) =>
      prev.includes(id)
        ? prev.filter((x) => x !== id)
        : [...prev, id]
    );
  };

  const toggleConfig = (id) => {
    setExpandedConfigs((prev) =>
      prev.includes(id)
        ? prev.filter((x) => x !== id)
        : [...prev, id]
    );
  };


  

  const handleRerun = async(run,config) => {
    console.log("Rerun:", run,config);
    try {
          setReRunId(run.id);
          const res = await apiFetch("file-mapping-config/re-reconciliation",
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                configId: config.id,
                uploadedFileId: run.id,
              }),
            }
          );
          const data = await res.json();
         // alert(JSON.stringify(data));
          
        } catch(err) {
          //alert("Process failed");
          console.log("Rerun **************",err);
        } finally {
          //setRunning(false);
        }

    // call your rerun API here
  };


  return (
    <div className="space-y-6">
      {/* Header */}
    <div></div>
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-xl font-bold text-slate-800">
            Program Explorer
          </h1>

          <p className="text-slate-500 mt-1">
            Browse programs, configurations and reconciliation runs.
          </p>
        </div>
      </div>

      {/* Tree */}

      <div className="bg-white border rounded-2xl overflow-hidden shadow-sm">

        {programs?.map((program) => {
          const programExpanded = expandedPrograms.includes(program?.id);

          return (
            <div key={program?.id} className="border-b last:border-b-0">

              {/* PROGRAM */}

              <div
                onClick={() => toggleProgram(program?.id)}
                className="
                  px-6
                  py-5
                  cursor-pointer
                  hover:bg-slate-50
                  transition
                "
              >
                <div className="flex items-center justify-between">

                  <div className="flex items-center gap-4">

                    {programExpanded ? (
                      <ChevronDown
                        className="text-slate-500"
                        size={18}
                      />
                    ) : (
                      <ChevronRight
                        className="text-slate-500"
                        size={18}
                      />
                    )}

                    <div className="w-11 h-11 rounded-xl bg-blue-100 flex items-center justify-center">
                      <FolderGit2
                        size={20}
                        className="text-blue-700"
                      />
                    </div>

                    <div>
                      <h3 className="font-semibold text-slate-800">
                        {program.programName}
                      </h3>

                      <div className="flex gap-4 mt-1 text-sm text-slate-500">

                        <span>
                          {program.configCount} Configs
                        </span>

                        <span>
                          {program.runCount} Runs
                        </span>

                      </div>
                    </div>
                  </div>

                  {/* Program Actions */}

                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      //alert(JSON.stringify(program))
                      navigate(`/programs/config/${program.id}`,{
                                            state: program,
                                    })
                      
                    }}
                    className="
                      flex
                      items-center
                      gap-2
                      px-4
                      py-2
                      rounded-lg
                      bg-primary
                      text-white
                      hover:bg-primary/90
                      transition
                      disabled:opacity-50
                    "
                  >
                    <Plus size={16} />
                    Add Config
                  </button>
                </div>
              </div>

              {/* CONFIGS */}

              {programExpanded && (
                <div className="bg-slate-50 border-t">

                  {program.configs?.map((config) => {
                    const configExpanded =
                      expandedConfigs.includes(config.id);

                    return (
                      <div
                        key={config.id}
                        className="ml-12 border-l border-slate-200"
                      >

                        {/* CONFIG */}

                        <div
                          onClick={() => toggleConfig(config.id)}
                          className="
                            px-6
                            py-4
                            cursor-pointer
                            hover:bg-slate-100
                            transition
                          "
                        >
                          <div className="flex items-center justify-between">

                            <div className="flex items-center gap-4">

                              {configExpanded ? (
                                <ChevronDown size={16} />
                              ) : (
                                <ChevronRight size={16} />
                              )}

                              <div className="w-10 h-10 rounded-lg bg-emerald-100 flex items-center justify-center">
                                <Settings2
                                  size={18}
                                  className="text-emerald-700"
                                />
                              </div>

                              <div>

                                <h4 className="font-medium text-slate-800">
                                  {config.configName}
                                </h4>

                                <p className="text-sm text-slate-500 mt-1">
                                  {config.runCount} runs
                                </p>

                              </div>
                            </div>

                            {/* Config Actions */}

                            <button
                              onClick={(e) => {
                                e.stopPropagation();

                               
                                  navigate(`/programs/configs/${program.id}`,{
                                            state: {program:program,config:config},
                                            
                                    })
                              }}
                              className="
                                flex
                                items-center
                                gap-2
                                px-4
                                py-2
                                rounded-lg
                                bg-emerald-600
                                text-white
                                hover:bg-emerald-700
                                transition
                              "
                            >
                              <Play size={16} />
                              Edit & Run
                            </button>
                          </div>
                        </div>

                        {/* RUNS */}

                        {configExpanded && (
                          <div className="ml-10 border-l border-slate-200 bg-white">

                            {config.uploadedFiles?.length > 0 ? (
                              config.uploadedFiles.map((run) => (
                                <div
                                  key={run.id}
                                  className="
                                    px-6
                                    py-4
                                    border-b
                                    hover:bg-slate-50
                                  "
                                >
                                  <div className="flex items-center justify-between">

                                    <div className="flex items-center gap-4">

                                      <div className="w-9 h-9 rounded-lg bg-violet-100 flex items-center justify-center">
                                        <PlayCircle
                                          size={16}
                                          className="text-violet-700"
                                        />
                                      </div>

                                      <div>

                                        <div className="flex items-center gap-3">

                                          <h5 className="font-medium">
                                            Run #{run.id}
                                          </h5>

                                          {!run.status && <span
                                            className={`
                                              px-2
                                              py-1
                                              rounded-full
                                              text-xs
                                              font-medium
                                              ${
                                                run.status
                                                  ? "bg-green-100 text-green-700"
                                                  : "bg-red-100 text-red-700"
                                              }
                                            `}
                                          >
                                            {run.status
                                              ? "Success"
                                              : "Failed"}
                                          </span>}
                                        </div>

                                        <div className="mt-1 space-y-1">
                                          <p className="text-sm text-slate-500">
                                            {run.created_at}
                                          </p>

                                          {run.status && <div className="flex flex-wrap items-center gap-2 text-xs">
                                            <span className="px-2 py-1 rounded-md bg-blue-100 text-blue-700 font-medium">
                                              Accuracy: {Number(run.accuracy || 0).toFixed(2)}%
                                            </span>

                                            <span className="px-2 py-1 rounded-md bg-green-100 text-green-700 font-medium">
                                              ✓ Matched: {run?.reconSummary?.matchedCount ?? 0}
                                            </span>

                                            <span className="px-2 py-1 rounded-md bg-red-100 text-red-700 font-medium">
                                              ✕ Unmatched: {run?.reconSummary?.missMatchedCount ?? 0}
                                            </span>
                                          </div>}
                                        </div>
                                        
                                      </div>
                                    </div>

                                    {/* Run Actions */}

                                    <div className="flex gap-2">

                                      <button
                                        onClick={() =>
                                          handleRerun(run,config)
                                        }
                                        className="
                                          flex
                                          items-center
                                          gap-2
                                          px-3
                                          py-2
                                          rounded-lg
                                          bg-amber-100
                                          text-amber-700
                                          hover:bg-amber-200
                                        "
                                      >
                                        <RotateCcw size={14} />
                                        Rerun
                                      </button>

                                      <button
                                        onClick={() =>
                                          navigate(`/programs/config/run/summary/${config.configName}`, {state: {
                                                "id": run.id,
                                                "source_file": config.sourceFile,
                                                "source_file_name": config.sourceFileName,
                                                "target_file": config.sourceFile,
                                                "target_file_name": config.targetFileName,
                                                "status": run.status,
                                                "created_at": run.createdAt,
                                                "file_mapping_id": config.id,
                                                "accuracy": run.accuracy,
                                                "config_name": config.configName,
                                                "program_name": program.programName,
                                                "program_id": program.id
                                            }
                                          })
                                        }
                                        className="
                                          flex
                                          items-center
                                          gap-2
                                          px-3
                                          py-2
                                          rounded-lg
                                          border
                                          hover:bg-slate-100
                                        "
                                      >
                                        <ChartColumn size={14} />
                                        Analysis
                                      </button>
                                    </div>
                                    {reRunId === run.id && (
                                        <div className="mt-3 space-y-2">
                                        <UploadProgress
                                          uploadId={`table_${run.id}_source`}
                                          onProgress={setFileProcessingStatus}
                                        />
                                        <UploadProgress
                                          uploadId={`table_${run.id}_target`}
                                          onProgress={setFileProcessingStatus}
                                        />
                                      </div>
                                    )}
                                  </div>
                                </div>
                              ))
                            ) : (
                              <div className="px-6 py-8 text-center text-slate-500">
                                No runs available.
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    );
                  })}

                  {program.configs?.length === 0 && (
                    <div className="p-8 text-center text-slate-500">
                      No configurations available.
                    </div>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}